/* globals dataLayer */

export function isGTMEnabled() {
	if (!dataLayer) {
		return false;
	}

	return !!dataLayer.find(v => v['gtm.start']);
}
